module.exports = {
  methods: {
    buildDateFilterDescription(filter, schema) {
      switch (Object.keys(schema)[0]) {
        case 'before':
          return `${filter.attributes.title} before ${schema.before.date}`
        case 'after':
          return `${filter.attributes.title} after ${schema.after.date}`
        case 'between':
          return `${filter.attributes.title} between ${schema.between.startDate} -  ${schema.between.endDate}`
      }
    },
    buildSelectFilterDescription(filter, selectedOptions) {
      switch (filter.id) {
        case 'groups':
          return this.buildMembershipGroupFilterDescription(selectedOptions)
        case 'zip-code':
          return this.buildZipCodeFilterDescription(selectedOptions)
        default:
          switch (selectedOptions.length) {
            case 0:
              return ''
            case 1:
              return `${filter.attributes.title} of ${selectedOptions[0].label}`
            default:
              const list = selectedOptions.map(value => value.label).join(', ')
              return `${filter.attributes.title} of one of the following: ${list}`
          }
      }
    },
    buildMembershipGroupFilterDescription(selectedOptions) {
      switch (selectedOptions.length) {
        case 0:
          return ''
        case 1:
          return `Be a member of the group - ${selectedOptions[0].label}`
        default:
          const list = selectedOptions.map(value => value.label).join(', ')
          return `Be a member of one of the following groups: ${list}`
      }

    },
    buildZipCodeFilterDescription(selectedOptions) {
      switch (selectedOptions.length) {
        case 0:
          return ''
        case 1:
          return `Have an address with the zip code - ${selectedOptions[0].label}`
        default:
          const list = selectedOptions.map(value => value.label).join(', ')
          return `Have an address with one of the following zip codes: ${list}`
      }

    },
  },
}